/**
 * DeviceAdapter — Web 구현. `navigator.language` 폴백.
 */

import type { DeviceAdapter, DeviceLanguageCode } from "./device";

const FALLBACK_LANGUAGE = "en";

export function createDeviceAdapter(): DeviceAdapter {
  return {
    async getLanguageCode(): Promise<DeviceLanguageCode> {
      const lang =
        (typeof navigator !== "undefined" && navigator.language) ||
        FALLBACK_LANGUAGE;
      return { value: lang };
    },
  };
}
